function Button({content, link}) {
    return (
      <button><a href={link} target="_blank" rel="noreferrer">{content}</a></button>
    );
  }
  
  export default Button;